<template>
  <v-card flat class="rounded-card">
    <v-card-text v-if="loading">
      <px-circular-loading/>
    </v-card-text>
    <v-card-text v-if="!loading">
      <p class="headline font-weight-bold mb-1 text--primary">
        {{user.nome}}
      </p>
      <div class="text--primary">
        <v-icon>mdi-email</v-icon> {{user.email}}
      </div>
      <div class="text--primary">
        <v-icon>mdi-phone</v-icon> {{user.whatsapp}}
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  props: {
    user: Object,
  },
};
</script>
